import { supabaseClient } from 'supabase'

export type RestoreRawItemParams = {
  rawItemId: number
  /** Public storage URL of the raw item's first stored image, or null for none. */
  mainPicture: string | null
}

/**
 * Restore a raw item the editor discarded whole into a new candidate on the
 * desk (`desk_restore_raw_item`, SECURITY DEFINER, D-12). Returns the new
 * application id.
 *
 * Errors are thrown raw, never swallowed: `desk_not_restorable` (22023, the
 * item is no longer discarded or was restored already) and `desk_bad_image`
 * reach `mapDeskError` unchanged.
 */
export const restoreRawItem = async ({
  rawItemId,
  mainPicture
}: RestoreRawItemParams): Promise<number> => {
  const { data, error } = await supabaseClient.rpc('desk_restore_raw_item', {
    p_raw_item_id: rawItemId,
    p_main_picture: mainPicture
  })

  if (error) {
    throw error
  }
  if (data === null || data === undefined) {
    throw new Error('desk_restore_raw_item returned no id')
  }
  return data
}
